var map = {
	"./NAAAPTampa.jpg": 54,
	"./logo/NAAAPTampa.jpg": 23,
	"./logo/amazon.jpg": 24,
	"./logo/lostwind.jpg": 25,
	"./logo/nielsen.jpg": 26,
	"./logo/sciencefiction.jpg": 27,
	"./logo/tampa.jpg": 28,
	"./lovehero-min.jpg": 55,
	"./lovehero.jpg": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;